import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function Icon({ className, style, name, title, disabled, onClick, ...props }) {
  const onClickHandler = e => {
    if (disabled) return
    if (onClick) return onClick(e)
  }

  return (
    <svg
      viewBox="0 0 100 100"
      className={clsx('icon', className)}
      style={{
        ...style,
        cursor: disabled ? 'default' : style?.cursor,
        filter: disabled ? 'grayscale(1)' : style?.filter
      }}
      onClick={onClickHandler}
      data-testid="icon"
      {...props}
    >
      {title && <title>{title}</title>}
      <use xlinkHref={`#${name}`} />
    </svg>
  )
}

Icon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.string.isRequired,
  props: PropTypes.object,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
}

Icon.defaultProps = {
  title: '',
  disabled: false
}
